import React from 'react'
// @ts-ignore
import { LKModalTrigger } from 'shared/LKModal'

export const AddClientFormTrigger = ({ children, permission, ...rest }) => (
  <LKModalTrigger params={rest} alias="client_add" name="AddClientModal" permission={permission}>
    {children}
  </LKModalTrigger>
)
